<template>
  <div>
    <AmaInlineValidation
      ref="amaTable"
      :participants="participants"
      :membershipType="membershipType"
      :itemOrg="itemOrg"
      :buttonColor="buttonColor"
      @state="onAmaState"
      @add-ama="onAddAma"
      @mismatch="onMismatch"
    />

    <v-row>
      <v-col md="6" sm="6" cols="6" class="text-left">
        <v-btn
          :color="`${buttonColor}`"
          class="btn_next"
          @click="setStep(previousStep)"
        >
          {{ $t("registerEvent.prev") }}
        </v-btn>
      </v-col>
      <v-col md="6" sm="6" cols="6" class="text-right">
        <v-btn
          outlined
          class="mr-4"
          :color="buttonColor"
          :loading="refreshing"
          :disabled="refreshing"
          @click="refresh"
        >
          {{ $t("results.details.refresh") }}
        </v-btn>
        <v-btn
          :color="`${buttonColor}`"
          class="btn_next"
          :disabled="isNextDisabled"
          @click="onNext"
        >
          {{ $t("registerEvent.next") }}
        </v-btn>
      </v-col>
    </v-row>

    <Snack :snack="snack" :snackMsg="snackMsg" :snackCol="snackCol" />
  </div>
</template>

<script>
import AmaInlineValidation from "@/components/memberRegistration/AmaInlineValidation";
import Snack from "@/components/notifications/Snack";
import { VRow, VCol, VBtn } from "vuetify/lib";

export default {
  name: "Step_AmaMembership",
  components: { AmaInlineValidation, Snack, VRow, VCol, VBtn },
  props: {
    participants: { type: Array, default: () => [] },
    membershipType: { type: Object, default: null },
    itemOrg: { type: Object, default: null },
    buttonColor: { type: String, default: "primary" },
    previousStep: { type: Number, default: 3 },
    nextStepValue: { type: Number, default: 4 }
  },
  data() {
    return {
      amaState: { verifications: {}, mismatches: {}, allValid: false },
      refreshing: false,
      snack: false,
      snackMsg: "",
      snackCol: "info"
    };
  },
  computed: {
    isNextDisabled() {
      return !this.amaState.allValid;
    }
  },
  methods: {
    async refresh() {
      if (!this.$refs.amaTable) return;
      this.refreshing = true;
      try {
        await this.$refs.amaTable.refresh();
      } finally {
        this.refreshing = false;
      }
    },
    setStep(value) {
      this.$emit("nextStep", value);
    },
    onNext() {
      if (this.isNextDisabled) {
        this.snack = true;
        this.snackCol = "error";
        this.snackMsg = this.$t("memberRegistration.ama_step.block_progress");
        setTimeout(() => { this.snack = false; }, 3000);
        return;
      }
      this.$emit("nextStep", this.nextStepValue);
    },
    onAmaState(state) {
      this.amaState = state || { verifications: {}, mismatches: {}, allValid: false };
      this.$emit("ama-state", this.amaState);
    },
    onAddAma(participant) {
      this.$emit("add-ama", participant);
    },
    onMismatch(payload) {
      this.$emit("ama-mismatch", payload);
    }
  }
};
</script>
